






























































































import {
  Component,
  Vue
} from "@/shared/vuepack";

import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import {
  hsabExpenseCategoryMap,
  ManagedExpenseFilterType,
  ManagedExpensesSortableColumns,
  SortOrder
} from "@/shared/types";
import { HsabExpenseManagement } from "@/employee/route-names";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
import _ from "lodash";

@Component({
  computed: {
    ManagedExpenseFilterType () {
      return ManagedExpenseFilterType;
    }
  }
})
export default class ManagedExpenseFilters extends Vue {
  managedExpensesStore = useManagedExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();
  featureFlagStore = useFeatureFlagStore();
  expenseCategoryIcon = expenseCategoryIcon;
  showAdditionalFiltersToggle = false;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;
  currentDateRangeFilter = null;
  debouncedSearchFunction = _.debounce(newText => this.onTextSearchChanged(newText), 400);
  sortDropdownOptions = [
    {
      column: ManagedExpensesSortableColumns.Amount,
      sortOrder: SortOrder.Ascending,
      text: "Amount ($ to $$$)"
    },
    {
      column: ManagedExpensesSortableColumns.Amount,
      sortOrder: SortOrder.Descending,
      text: "Amount ($$$ to $)"
    },
    {
      column: ManagedExpensesSortableColumns.Date,
      sortOrder: SortOrder.Ascending,
      text: "Date (Old to New)"
    },
    {
      column: ManagedExpensesSortableColumns.Date,
      sortOrder: SortOrder.Descending,
      text: "Date (New to Old)"
    },
    {
      column: ManagedExpensesSortableColumns.Provider,
      sortOrder: SortOrder.Ascending,
      text: "Merchant/Provider (A to Z)"
    },
    {
      column: ManagedExpensesSortableColumns.Provider,
      sortOrder: SortOrder.Descending,
      text: "Merchant/Provider (Z to A)"
    },
    {
      column: ManagedExpensesSortableColumns.PlanName,
      sortOrder: SortOrder.Ascending,
      text: "Plan Name (A to Z)"
    },
    {
      column: ManagedExpensesSortableColumns.PlanName,
      sortOrder: SortOrder.Descending,
      text: "Plan Name (Z to A)"
    },
    {
      column: ManagedExpensesSortableColumns.Status,
      sortOrder: SortOrder.Ascending,
      text: "Status (A to Z)"
    },
    {
      column: ManagedExpensesSortableColumns.Status,
      sortOrder: SortOrder.Descending,
      text: "Status (Z to A)"
    },
  ];

  created () {
    this.managedExpensesStore.loadUserHasHealthPlanExpense();
  }

  get showHealthPlanFilter () {
    return this.managedExpensesStore.userHasHealthPlanExpense;
  }

  get showAdditionalFilters () {
    return this.featureFlagStore.flags.bend20105ExpenseFilters && this.showAdditionalFiltersToggle;
  }

  get showActionNeededFilter () {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get showMyExpenseFilter () {
    return (this.showHealthPlanFilter || this.showActionNeededFilter);
  }

  get showAdditionalFiltersButton () {
    return this.featureFlagStore.flags.bend20105ExpenseFilters;
  }

  get categoryFilterOptions () {
    const results = [
      {
        text: "All",
        value: null
      }
    ];
    for (const category of this.managedExpensesStore.filterOptions.categories) {
      results.push({
        text: hsabExpenseCategoryMap[category],
        value: category.toString(),
      });
    }
    return results;
  }

  get dateRangeFilterOptions () {
    const results = [
      {
        text: "All",
        value: null
      },
      {
        text: "Year to date",
        value: "ytd"
      },
      {
        text: "Last 12 months",
        value: "last12"
      },
    ];
    for (const year of this.managedExpensesStore.filterOptions.years) {
      results.push({
        text: year.toString(),
        value: year.toString(),
      });
    }
    return results;
  }

  get isCategoryFilterInUse () {
    return this.managedExpensesStore.currentPage.categoryFilter !== null;
  }

  get isDateRangeFilterInUse () {
    return this.managedExpensesStore.currentPage.startDateFilter !== null
        || this.managedExpensesStore.currentPage.endDateFilter !== null;
  }

  get categoryFilterDisplay () {
    if (this.managedExpensesStore.currentPage.categoryFilter) {
      return "Category: " + hsabExpenseCategoryMap[this.managedExpensesStore.currentPage.categoryFilter];
    }

    return "Select a category";
  }

  get dateRangeFilterDisplay () {
    if (this.isDateRangeFilterInUse) {
      return "Date Range: " + this.currentDateRangeFilter;
    }

    return "Select a date range";
  }

  get filtersToggleDisplayText () {
    return this.showAdditionalFiltersToggle ? "Hide Filters" : (this.showMyExpenseFilter ? "More filters" : "Filters");
  }

  get sortOrderDisplay () {
    const currentSortOrderOption = _.find(this.sortDropdownOptions, x =>
        x.column === this.managedExpensesStore.currentPage.sortByColumn &&
        x.sortOrder === this.managedExpensesStore.currentPage.sortOrder);
    return "Sort Order: " + currentSortOrderOption.text;
  }

  onFilterClicked (filter: ManagedExpenseFilterType) {
    if (!this.$route.params.filter || filter !== this.$route.params.filter) {
      this.$router.replace({ name: HsabExpenseManagement, params: { filter }});
    }
  }

  onToggleMoreFilterClicked () {
    this.showAdditionalFiltersToggle = !this.showAdditionalFiltersToggle;
  }

  onCategoryFilterChanged (categoryOption) {
    this.managedExpensesStore.setCategoryFilter(categoryOption.value);
  }

  onDateRangeFilterChanged (dateRangeOption) {
    this.currentDateRangeFilter = dateRangeOption.text;
    this.managedExpensesStore.setDateRangeFilter(dateRangeOption.value);
  }

  onTextSearchChanged (text) {
    this.managedExpensesStore.setTextSearch(text);
  }

  onSortOrderSelected (sortOption) {
    this.managedExpensesStore.setSortByColumnAndSortOrder(sortOption.column, sortOption.sortOrder);
  }
}
